import { render } from "./table-page.html?vue&type=template&id=3ace1edc&scoped=true&ts=true"
import script from "./table-page.ts?vue&type=script&lang=ts"
export * from "./table-page.ts?vue&type=script&lang=ts"

import "./table-page.scss?vue&type=style&index=0&id=3ace1edc&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ace1edc"]])

export default __exports__